import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { leaders, advisoryBoard } from "../data/teamData";
import "./TeamStyle.css";

import Team1 from "../components/Team/Team";

function Team() {
  return (
    <div className="team-container">     
     <section className="about-section">
        <Team1 />
      </section>

    </div>
  );
}

export default Team;
